import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

import UserChatBubble2 from "@/Components/Forms/FirmUserBtn2";

const MessageInput = ({ onSendMessage, onTyping, placeholder, disabled, recipient }) => {
  const [message, setMessage] = useState("");
  const [_isEmojiPickerOpen, _setIsEmojiPickerOpen] = useState(false);
  const textareaRef = useRef(null);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message);
      setMessage("");
      resetTextareaHeight();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleChange = (e) => {
    setMessage(e.target.value);
    onTyping?.();
    adjustTextareaHeight();
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
    }
  };

  const resetTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
    }
  };

  // const addEmoji = (emoji) => {
  //   setMessage((prev) => prev + emoji);
  //   setIsEmojiPickerOpen(false);
  //   textareaRef.current?.focus();
  // };

  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  const recipientName = recipient?.name || recipient?.case_display || "";
  const recipientNameParts = recipientName.trim().split(/\s+/).filter(Boolean);
  const recipientFirstName = recipient?.first_name || recipientNameParts[0] || "";
  const recipientLastName = recipient?.last_name || recipientNameParts.slice(1).join(" ") || "";

  // const commonEmojis = [
  //   "😀",
  //   "😂",
  //   "😍",
  //   "🤔",
  //   "👍",
  //   "👎",
  //   "❤️",
  //   "🎉",
  //   "🔥",
  //   "💯",
  //   "😊",
  //   "😎",
  //   "🙄",
  //   "😴",
  //   "🤝",
  //   "👋",
  // ];

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        padding: "5px",
        paddingRight: "15px",
        backgroundColor: "var(--primary-60)",
        // borderTop: "1px solid #e5e7eb",
        // borderBottom: "1px solid #e5e7eb",
      }}
    >
      <div
        style={{
          flex: "1 1 auto",
          minWidth: 0,
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          minHeight: "35px",
          padding: "0 8px 0 6px",
          boxSizing: "border-box",
          border: "1px solid #d1d5db",
          borderRadius: "20px",
          backgroundColor: "white",
        }}
        onClick={() => textareaRef.current?.focus()}
      >
        {recipient && (recipientFirstName || recipientLastName) && (
          <div style={{ flexShrink: 0 }}>
            <UserChatBubble2
              isActive={userOnlineStatus?.[recipient?.other_participant_id]?.isOnline ?? false}
              first_name={recipientFirstName}
              last_name={recipientLastName}
              width={19}
              profilePic={recipient?.client_avatar || recipient?.avatar_url || ""}
              onClick={() => textareaRef.current?.focus()}
              hideIcon={true}
            />
          </div>
        )}
        <textarea
          ref={textareaRef}
          value={message}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={(e) => {
            e.target.style.color = "black";
          }}
          onBlur={(e) => {
            e.target.style.color = "var(--primary-25)";
          }}
          style={{
            flex: "1 1 auto",
            width: "auto",
            minWidth: 0,
            boxSizing: "border-box",
            padding: "6px 0",
            border: "none",
            borderRadius: 0,
            resize: "none",
            fontSize: "14px",
            lineHeight: "1.5",
            minHeight: "35px",
            height: "auto",
            // maxHeight: "120px",
            outline: "none",
            transition: "all 0.2s ease",
            backgroundColor: "transparent",
            fontFamily: "inherit",
            scrollbarWidth: "none",
          }}
          rows={1}
        />

        {/* <div
          style={{
            position: "absolute",
            right: "4px",
            bottom: "1px",
            display: "flex",
            gap: "4px",
          }}
        >
          <button
            type="button"
            style={{
              width: "32px",
              height: "32px",
              border: "none",
              borderRadius: "50%",
              backgroundColor: "transparent",
              color: "#6b7280",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
            onClick={() => setIsEmojiPickerOpen(!isEmojiPickerOpen)}
            title="Add emoji"
          >
            😀
          </button>
        </div> */}
        {/* 
        {isEmojiPickerOpen && (
          <div
            style={{
              position: "absolute",
              bottom: "38px",
              right: "16px",
              backgroundColor: "white",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              padding: "12px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
              zIndex: 10,
              display: "grid",
              gridTemplateColumns: "repeat(8, 1fr)",
              gap: "8px",
              maxWidth: "320px",
            }}
          >
            {commonEmojis.map((emoji, index) => (
              <button
                key={index}
                type="button"
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  transition: "background-color 0.2s ease",
                }}
                onClick={() => addEmoji(emoji)}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
              >
                {emoji}
              </button>
            ))}
          </div>
        )} */}
      </div>

      <button
        type="submit"
        disabled={!message.trim() || disabled}
        // style={{
        //   padding: "10px 20px",
        //   backgroundColor: disabled || !message.trim() ? "#9ca3af" : "var(--primary, #3b82f6)",
        //   color: "white",
        //   border: "none",
        //   borderRadius: "24px",
        //   cursor: disabled || !message.trim() ? "not-allowed" : "pointer",
        //   minHeight: "44px",
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "center",
        //   gap: "8px",
        //   transition: "all 0.2s ease",
        //   fontWeight: "600",
        //   fontSize: "14px",
        // }}
        style={{
          // position: "absolute",
          // top: "4px",
          // right: "20px",
          // zIndex: 10,

          padding: "6px 12px",
          borderRadius: "20px",
          fontSize: "14px",
          fontWeight: "600",
          backgroundColor: disabled || !message.trim() ? "var(--primary-25)" : "#008000",
          color: "white",
          // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          height: "35px",
          flexShrink: 0,
        }}
        title="Send message (Enter)"
      >
        {/* <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            fill="none"
          />
        </svg> */}
        Send Chat
      </button>
    </form>
  );
};

export default MessageInput;
